import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { SolicitudesCreditoFacturadasHeader } from "../SolicitudesCreditoFacturadas/SolicitudesCreditoFacturadasHeader";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FiltradoOperacionesCredito } from "../TiemposOperacion/FiltradoOperacionesCredito";
import { useLocation } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import Swal from "sweetalert2";
import { TablaResumenGerente } from "./TablaResumenGerente";
import { FiltroCumplimientoCondicionadas } from "./FiltroCumplimientoCondicionadas";
import { TablaResumenDetalle } from "./TablaResumenDetalle";
import { FiltroCumplimientoCondicionadasDetalle } from "./FiltroCumplimientoCondicionadasDetalle";
import { useBox } from "../../CreditoyCobranza/ReporteCobranza/Helper/useBox";
import { GetKey, GetKeyArray } from "../../../Helpers/GetKey";

export const CumplimientoDocumentacionCondicionadaScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const [cardSelected, setCardSelected] = useState(1);
    const [boxstate, setBoxState] = useBox();
    const [titulo, setTitulo] = useState({
        main: "OPERACIONES CONDICIONADAS",
        show: "OPERACIONES CONDICIONADAS",
        ejercicio: 0,
        sucursal: 0,
    });
    const [state, setState] = useState({
        resumen: {},
        data: [],
    });
    const [dataCard, setDataCard] = useState([]);
    const [meses, setMeses] = useState([]);
    const [totales, setTotales] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [tableshow, setTableShow] = useState("G");
    // const onExecute = (ejercicio) => {
    // var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    // var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    // if (sucursales === undefined || sucursales === null || sucursales === "") {
    //     sucursales = "0";
    // }
    // if (adr === undefined || adr === null || adr === "") {
    //     adr = "0";
    // }
    //     console.log(ejercicio, sucursales, adr)
    //     // const Linea =
    //     //     linea !== null && linea !== "" && linea !== undefined ? linea : "TT";
    //     return new Promise((resolve, rejec) => {
    //         setLoader({ ...loader, mostrar: true });
    //         request
    // .get(
    //     // `CumplimientoCondicionadas/ObtenerGeneral?ejercicio=${Number(
    //     //     ejercicio
    //     // )}&sucursal=${Number(sucursales)}&adr=${adr}`
    //     `CumplimientoCondicionadas/ObtenerGeneral?ejercicio=2024&sucursal=1`
    // )
    //             .then((result) => {
    //                 setLoader({ ...loader, mostrar: false });
    //                 if (
    //                     result.result.detalle.length === undefined ||
    //                     result.result.detalle.length === null ||
    //                     result.result.detalle.length === 0
    //                 ) {
    //                     Swal.fire(titulo.show, "Sin solicitudes en esta sucursal", "warning");
    //                 }
    //                 setState({
    //                     resumen: result.result.resumen,
    //                     data: result.result.detalle,
    //                 });
    //                 setMeses(result.arrayMes)
    //                 setTableShow("G");
    //                 setTitulo({
    //                     ...titulo,
    //                     show: result.result.resumen.titulo,
    //                     ejercicio,
    //                     // sucursal,
    //                 });
    //                 resolve("");
    //                 return;
    //             })
    //             .catch((error) => {
    //                 setLoader({ ...loader, mostrar: false });
    //                 rejec(error);
    //                 return;
    //             });
    //     });
    // };

    const onExecute = () => {
        return new Promise((resolve, rejec) => {
            // console.log(boxstate)
            if (
                boxstate.ejercicioinicio === undefined ||
                boxstate.ejercicioinicio === null ||
                boxstate.ejercicioinicio === ""
            ) {
                rejec("Favor de agregar el ejercicio de inicio");
                return;
            }
            if (
                boxstate.periodoinicio === undefined ||
                boxstate.periodoinicio === null ||
                boxstate.periodoinicio === ""
            ) {
                rejec("Favor de agregar el periodo de inicio");
                return;
            }
            const fechainicio = new Date(
                boxstate.ejercicioinicio,
                Number(boxstate.periodoinicio) - 1,
                "01"
            );
            const fechafin = new Date(
                boxstate.ejerciciofin,
                Number(boxstate.periodofin) - 1,
                "01"
            );

            const ejercicio = boxstate.ejercicioinicio === 0 ? boxstate.ejercicio : boxstate.ejercicioinicio
            // const periodo = boxstate.periodoinicio === 0 ? 1 : boxstate.periodoinicio
            var sucursales = GetKeyArray(boxstate.pv.sucursal, ["idsucursal"]);
            var adr = GetKeyArray(boxstate.pv.adr, ["idadr"]);
            var periodo = GetKeyArray(boxstate.pk.periodo, ["idMes"]);
            if (sucursales === undefined || sucursales === null || sucursales === "") {
                sucursales = "0";
            }
            if (adr === undefined || adr === null || adr === "") {
                adr = "0";
            }
            if (periodo === undefined || periodo === null || periodo === "") {
                periodo = "0";
            }

            request
                .get(
                    // `CumplimientoCondicionadas/ObtenerGeneral?ejercicio=${Number(
                    //     ejercicio
                    // )}&sucursal=${Number(sucursales)}&adr=${adr}`
                    `CumplimientoCondicionadas/ObtenerGeneral?ejercicio=${Number(ejercicio)}&sucursales=${sucursales}&adr=${adr}&periodo=${periodo}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    if (
                        result.result.detalle.length === undefined ||
                        result.result.detalle.length === null ||
                        result.result.detalle.length === 0
                    ) {
                        Swal.fire(titulo.show, "Sin solicitudes en esta sucursal", "warning");
                    }
                    setCardSelected(1)
                    setState({
                        resumen: result.result.resumen,
                        data: result.result.detalle,
                    });
                    setMeses(result.arrayMes)
                    setTotales(result.totalesPorMes)
                    setTableShow("G");
                    setTitulo({
                        ...titulo,
                        show: result.result.resumen.titulo,
                        // ejercicio,
                        // sucursal,
                    });
                    resolve("");
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    rejec(error);
                    return;
                });
        });
    };

    const onCargarDetalle = (Gerente) => {
        setLoader({ ...loader, mostrar: true });

        const ejercicio = boxstate.ejercicioinicio === 0 ? boxstate.ejercicio : boxstate.ejercicioinicio
        var periodo = GetKeyArray(boxstate.pk.periodo, ["idMes"]);
        var sucursales = GetKeyArray(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKeyArray(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        if (periodo === undefined || periodo === null || periodo === "") {
            periodo = "0";
        }

        request
            .get(
                `CumplimientoCondicionadas/ObtenerDetalle?usuario=${Number(Gerente)}&ejercicio=${Number(
                    ejercicio
                )}&sucursales=${sucursales}&adr=${adr}&periodo=${periodo}`
            )
            .then((result) => {
                // console.log(result)
                setLoader({ ...loader, mostrar: false });
                if (
                    result.result.length === undefined ||
                    result.result.length === null ||
                    result.result.length === 0
                ) {
                    Swal.fire(titulo.show, "No se encontraron registros", "warning");
                }
                setDataCard(result.result);
                setMeses(result.arrayMes)
                setTotales(result.totalesPorMes)
                // setCardCerrados({
                //     card: cardseleccionado,
                //     titulo,
                // });
                setTableShow("O");
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
    };

    return (
        <PlantillaScreen
            titulo={titulo.show}
            className_main={1}
            className={"solicitud-credito-facturada"}
        >
            <div className="solicitud-credito-facturada-actions-A">
                <div
                    className="solicitud-credito-facturada-actions-regresar-A"
                    onClick={() => history.push("/Credito/Main")}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                {/* <FiltroCumplimientoCondicionadas
                    onExecute={onExecute}
                    setCardSelected={setCardSelected}
                /> */}
                <FiltroCumplimientoCondicionadasDetalle
                    boxState={boxstate}
                    onBoxChange={setBoxState}
                    BoxClick={onExecute}
                    titulo="Estado de Resultados por Periodo"
                    subtitulo={state.subtitulo}
                    titulo_filtro="FILTRO DE OPERACIONES"
                    setCardSelected={setCardSelected}
                />
            </div>
            {/* <div className="solicitud-credito-facturada-actions-excel">
                <div
                    className="solicitud-credito-facturada-actions-excel-button"
                    onClick={() => onGeneraExcel()}
                >
                    <ArticleIcon /> Excel
                </div>
            </div> */}

            <LoaderScreen loader={loader} />
            {state.data !== undefined &&
                state.data !== null &&
                state.data.length > 0 ? (
                <div className="solicitud-credito-facturada-container">
                    <div className="solicitud-credito-facturada-container-resumen">
                        <SolicitudesCreditoFacturadasHeader
                            titulo={"TOTAL"}
                            cantidad={state.resumen.total_condicionado}
                            className={
                                "solicitud-credito-facturada-container-resumen-item-click"
                            }
                            onClick={() => {
                                onExecute(titulo.ejercicio, titulo.sucursal);
                                setCardSelected(1);
                            }}
                            porcentaje={state.resumen.porcentaje_documentos_entregados + "%"}
                            activo={cardSelected === 1 ? true : false}
                        />
                        <SolicitudesCreditoFacturadasHeader
                            titulo={"David Tamayo"}
                            className={
                                "solicitud-credito-facturada-container-resumen-item-click"
                            }
                            cantidad={state.resumen.condicionado_davidt}
                            porcentaje={`${FormatMoney(state.resumen.porcentaje_condicionado_davidt)}%`}
                            onClick={() => {
                                onCargarDetalle(8929);
                                setCardSelected(2);
                            }}
                            activo={cardSelected === 2 ? true : false}
                        />
                        <SolicitudesCreditoFacturadasHeader
                            titulo={"Armando Guerrero"}
                            cantidad={state.resumen.condicionado_armandog}
                            box_bg_color="box-bg-yellow"
                            porcentaje={`${FormatMoney(state.resumen.porcentaje_condicionado_armandor)}%`}
                            className={
                                "cumplimiento-compromiso-condicionadas-container-resumen-item-click"
                            }
                            onClick={() => {
                                onCargarDetalle(6033);
                                setCardSelected(3);
                            }}
                            activo={cardSelected === 3 ? true : false}
                        />
                        <SolicitudesCreditoFacturadasHeader
                            titulo={"Ivan Lopez"}
                            cantidad={state.resumen.condicionado_ivanl}
                            porcentaje={`${FormatMoney(state.resumen.porcentaje_condicionado_ivanl)}%`}
                            className={
                                "solicitud-credito-facturada-container-resumen-item-click"
                            }
                            onClick={() => {
                                onCargarDetalle(5630);
                                setCardSelected(4);
                            }}
                            activo={cardSelected === 4 ? true : false}
                        />
                        <SolicitudesCreditoFacturadasHeader
                            titulo={"Mauricio Rodriguez"}
                            cantidad={state.resumen.condicionado_mauricior}
                            porcentaje={`${FormatMoney(state.resumen.porcentaje_condicionado_mauricior)}%`}

                            className={
                                "cumplimiento-compromiso-condicionadas-container-resumen-item-click"
                            }
                            onClick={() => {
                                onCargarDetalle(8994);
                                setCardSelected(5);
                            }}
                            activo={cardSelected === 5 ? true : false}
                        />
                    </div>
                    <div className="solicitud-credito-facturada-container-table">
                        {tableshow === "G" ? (
                            <TablaResumenGerente
                                data={state.data}
                                arrayMes={meses}
                                titulo={titulo}
                                filtro={boxstate}
                                totales={totales}
                            />
                        ) : (
                            <TablaResumenDetalle
                                data={dataCard}
                                arrayMes={meses}
                                titulo={titulo}
                                filtro={boxstate}
                                totales={totales}
                            />
                        )}
                    </div>
                </div>
            ) : (
                <></>
            )}
        </PlantillaScreen>
    );
};
